<template>
  <section class="register" @submit.native.prevent>
    <div class="title_wrap">
        <span class="title_name">创建新账号</span>
    </div>
    <el-form :model="regist" ref="registBasic" class="register-form"  size="medium">
        <div class="label">账号信息填写</div>
        <el-form-item prop="username" :rules="[ { required: true, message: '请输入用户名', trigger: 'blur'} ]">
            <el-input v-model.trim="regist.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item prop="pwd" :rules="[{ required: true, validator: validatePass, trigger: 'blur'}]">
            <el-input type="password" v-model="regist.pwd" placeholder="密码" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="pwd2" :rules="[{ required: true, validator: validatePass2, trigger: 'blur'}]">
            <el-input type="password" v-model="regist.pwd2" placeholder="确认密码" auto-complete="off"></el-input>
        </el-form-item>
    </el-form>
    <el-form :model="regist" ref="registExtra" class="register-form" size="medium">
        <div class="label">基本信息填写</div>
        <el-form-item prop="name" :rules="[{ required: true, message: '请输入姓名', trigger: 'blur'}]">
            <el-input v-model="regist.name" placeholder="联系人（请输入真实姓名）"></el-input>
        </el-form-item>
        <el-form-item prop="phone" :rules="[{ required: true, validator: checkPhone, trigger: 'blur'}]">
            <el-input v-model="regist.phone" placeholder="联系电话（作为我们联系您的方式请务必真实）"></el-input>
        </el-form-item>
        <el-form-item prop="email" :rules="[{ required: true, validator: checkEmail, trigger: 'blur'}]">
            <el-input v-model="regist.email" placeholder="请输入邮箱（作为我们联系您的方式请务必真实）"></el-input>
        </el-form-item>
        <el-select class="cselect" v-model="regist.school" filterable placeholder="请选择学校">
          <el-option
            v-for="item in schools"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-form-item v-if="regist.school == '0'" prop="otherschool" >
            <el-input v-model="regist.otherschool" placeholder="请输入学校名称"></el-input>
        </el-form-item>
        <el-form-item prop="province" :rules="[{ required: true, message: '请选择省份', trigger: 'blur'}]">
            <el-select class="cselect" v-model="regist.province" filterable placeholder="请选择学校所在省份">
              <el-option
                v-for="item in provs"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="addr" :rules="[{ required: true, message: '请输入地址', trigger: 'blur'}]">
            <el-input v-model="regist.addr" placeholder="地址"></el-input>
        </el-form-item>
        <div class="register-confirm">
          <span @click="save" class="submit">注册</span>
        </div>
        <div class="go_login">
          <a href="#/login">已有账号？点此处登陆</a>
        </div> 
    </el-form>
  </section>
</template>

<script>
import { Loading } from 'element-ui'
import axios from 'axios'

export default {
  data () {
    return {
      url: this.API,
      schools: [],
      provs:[{label:"北京市",value:"北京市"},
            {label:"天津市",value:"天津市"},
            {label:"河北省",value:"河北省"},
            {label:"山西省",value:"山西省"},
            {label:"内蒙古自治区",value:"内蒙古自治区"},
            {label:"辽宁省",value:"辽宁省"},
            {label:"吉林省",value:"吉林省"},
            {label:"黑龙江省",value:"黑龙江省"},
            {label:"上海市",value:"上海市"},
            {label:"江苏省",value:"江苏省"},
            {label:"浙江省",value:"浙江省"},
            {label:"安徽省",value:"安徽省"},
            {label:"福建省",value:"福建省"},
            {label:"江西省",value:"江西省"},
            {label:"山东省",value:"山东省"},
            {label:"河南省",value:"河南省"},
            {label:"湖北省",value:"湖北省"},
            {label:"湖南省",value:"湖南省"},
            {label:"广东省",value:"广东省"},
            {label:"广西壮族自治区",value:"广西壮族自治区"},
            {label:"海南省",value:"海南省"},
            {label:"重庆市",value:"重庆市"},
            {label:"四川省",value:"四川省"},
            {label:"贵州省",value:"贵州省"},
            {label:"云南省",value:"云南省"},
            {label:"西藏自治区",value:"西藏自治区"},
            {label:"陕西省",value:"陕西省"},
            {label:"甘肃省",value:"甘肃省"},
            {label:"青海省",value:"青海省"},
            {label:"宁夏回族自治区",value:"宁夏回族自治区"},
            {label:"新疆维吾尔自治区",value:"新疆维吾尔自治区"},
            {label:"台湾省",value:"台湾省"},
            {label:"香港特别行政区",value:"香港特别行政区"},
            {label:"澳门特别行政区",value:"澳门特别行政区"}
      ],
      regist: {
        username: '',
        pwd: '',
        pwd2: '',
        name: '',
        phone: '',
        addr: '',
        province: '',
        school: '',
        otherschool: '',
        email: ''
      }
    }
  },
  mounted(){
    this.initData();
  },
  methods: {
    validatePass: function (rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.regist.pwd2 !== '') {
          this.$refs.registBasic.validateField('pwd2')
        }
        callback()
      }
    },
    validatePass2: function (rule, value, callback) {
      if (value === '') {
        return callback(new Error('请再次输入密码'))
      } else if (value !== this.regist.pwd) {
        return callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    },
    checkPhone: function (rule, value, callback) {
      const phoneReg = /^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/
      if (!value) {
        return callback(new Error('电话号码不能为空'))
      }
      setTimeout(() => {
        if (phoneReg.test(value) && 11 == value.length) {
          callback()
        } else {
          callback(new Error('请输入格式正确的11位电话号码'))
        }
      }, 100)
    },
    checkEmail: function (rule, value, callback) {
      const mailReg = /^([.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }, 100)
    },
    initData: function () {
      let _t = this
      let ld = Loading.service({'fullscreen': true, 'text': '数据加载中，请稍后'})
      axios.post(_t.API + '/api/base/schoollist/')
          .then(function (resp) {
            if (resp.data.code === '0') {
              for (var i=0; i<resp.data.data.length; i++) {
                var item = resp.data.data[i]
                _t.schools.push({value: item.name, label: item.name}) 
              }
              _t.schools.push({value: '0', label: '其他'}) 
            } else {
              _t.$messagewarning(resp.data.msg)
            }

            ld.close()
          })
          .catch(function (error) {
            console.log(error)
            ld.close()
          })
    },
    save: function () {
      let _t = this
      _t.$refs.registBasic.validate((valid) => {
        if (!valid) {
          return
        }
      })
      _t.$refs.registExtra.validate((valid) => {
        if (valid) {
          if (_t.regist.school == '0' && _t.regist.otherschool == '') {
            _t.$messagewarning(请输入学校名称)
            return
          }
          let ld = Loading.service({'fullscreen': true, 'text': '数据提交中，请稍后'})
          axios.post(_t.API + '/api/regist/', _t.regist)
            .then(function (resp) {
              if (resp.data.code === '0') {
                _t.$messagesuccess(resp.data.msg)
                _t.$router.push('/login/')
              } else {
                _t.$messagewarning(resp.data.msg)
              }

              ld.close()
            })
            .catch(function (error) {
              console.log(error)
              ld.close()
            })
        }
      })
    }
  }
}
</script>

<style scoped lang='stylus'>
@import '~@/common/stylus/index'

.register{
    padding: 50px calc((100% - 800px) / 2);
}
.register-form{
	margin: 35px 0;
}
.register-form input {

}
.register-book .button {
  width: 130px;
  background-color: #959595;
  color: #fff;
  position: absolute;
  right: 0;
  top: 0;
  height: 48px;
  line-height: 48px;
  border-radius: 4px;
  font-size: 18px;
}
.register-book button, .register-book input {
  height:40px;
  width:100%;
  font-size: 17px;
  margin-top: 30px;
  padding: 0 10px;
  border: 1px solid #E8F0FE;
  border-radius: 2px;
}
.register-book button {
  width: 130px;
  background-color: #959595;
  color: #fff;
  position: absolute;
  right: 0;
  top: 0;
}
.register-confirm {
  text-align: center;
}
.register-confirm .submit {
  height: 48px;
  line-height: 48px;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 18px;
  background-color: #bc65d6;
  color: #fff;
  text-align: center;
  width: 210px;
  margin-top: 10px;
  cursor: pointer;
}
.title_wrap{
    border-bottom: 1px solid #a3a3a3;
    margin-bottom: 5px;
    text-align: left;
    position: relative;
}
.title_name{
    font-family: sy;
    border-bottom: 4px solid #bc65d6;
    color: black;
    font-weight:600;
    font-size: 20px;
}
.register_code{
  width:70%;
}
.el-input--medium .el-input__inner{
  height:40px;
  font-size:17px;
}
.register-form>p{
  /*border-radius: 2px;
  height:68px;
  line-height: 40px;
  color:white;
  font-family: sy;
  width:100%;
  cursor: pointer;
  font-size: 17px;*/
  text-align:center;
  width:100%;
}
.el-button--medium{
  font-size: 15px;
  /* margin-left:19px; */
}
.go_login{
  text-align: center;
  font-family: sy;
  font-size: 17px;
}
.go_login a{
  color:#a3a3a3;
}
.go_login a:hover{
  text-decoration: underline;
  color: #bc65d6;
}
.next{
    border-radius: 2px;
    background: #bc65d6;
    height: 40px !important;
    line-height: 40px;
    color: white;
    font-family: sy;
    width: 300px;
    cursor: pointer;
    font-size: 17px;
}
.label{
  margin 0 0 20px 0
  font-size 16px
  line-height 24px
  color $color-light-gray
  text-align center 
}
.cselect{
  width: 100%;
  margin-bottom: 22px;
}
 .el-input__inner{
  background-color: white;
  border: 1px solid #bc65d6 !important;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// Regist.vue?37adb656